import React, { useCallback, useEffect, useState } from 'react';

import { toDate } from 'date-fns';

import { Locale } from '../../../assets/Locale';

import "./Timer.scss";
import { Clock } from '../Clock/Clock';


export const Timer = (props)=>{
    const {value:raw, clockOpt={}, targetOpt } = props;
    const say = Locale.use();

    const value = toDate(raw);

    const recalc = useCallback(_=>value - Date.now(), [value]);
    const [msDiff, setTimeDiff] = useState(recalc);

    const refreshInterval = clockOpt?.includeSeconds ? 50 : 1000;

    useEffect(_=>{
        const int = setInterval(_=>setTimeDiff(recalc), refreshInterval);
        return _=>clearInterval(int);
    }, [recalc, refreshInterval]);

    const mode = msDiff === 0 ? "Now" : msDiff < 0 ? "Past" : "Future";
    if (mode === "Past") { clockOpt.unitIdSuffix = 7; } //now will be formated still like future

    const displayTrait = useCallback(v=>mode === "Now" ? v : say(`date${mode}Wrap`).replace("$", v), [mode]);
    
    return (
        <div className={["Timer", `timer${mode}`].join(" ")}>
            {value && <Clock value={Math.abs(msDiff)} opt={clockOpt} trait={displayTrait}/>}
            {(targetOpt && value) && <p className="targetDate">{say.dateTime(value, targetOpt)}</p>}
        </div>
    )
}

